import { getABNVariant } from '@r1-frontend/shared/helpers/abn-tests';

export const isShowShoppingCart = () => getABNVariant('custom_shopping_cart') === 'show_cart';
